import React from 'react';

import {FlexColumn} from '../FlexColumn';
import {Typography} from '../Text';
import {spacing} from '../../styles/vars';

import {Input} from './styles';

type InputFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  name?: string;
  disabled?: boolean;
  maxLength?: number;
  dataCy?: string;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
};

const InputField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  name,
  disabled,
  maxLength,
  dataCy,
  onFocus
}: InputFieldProps) => (
  <FlexColumn gap={spacing.spacing005}>
    <Typography as="label" htmlFor={id} color="secondary">
      {label}
    </Typography>
    <Input
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={placeholder}
      disabled={disabled}
      maxLength={maxLength}
      data-cy={dataCy}
    />
  </FlexColumn>
);

export default InputField;
